import { format } from "date-fns";

export const LeaveApplicationsColumns = [
  { field: "id", headerName: "ID", flex: 0.3 },
  { field: "firstName", headerName: "First Name", flex: 1 },
  { field: "lastName", headerName: "Last Name", flex: 1 },
  //  { field: "phoneNumber", headerName: "Phone Number", flex: 1.5 },
  //  { field: "email", headerName: "Email", flex: 1.5 },
  // { field: "gender", headerName: "Gender", flex: 1 },
  { field: "leaveType", headerName: "Leave Type", flex: 1.3 },
  // include createdDate so sorting by it is possible; hide by default
  {
    field: "createdDate", headerName: "Created", flex: 1, type: "dateTime", hide: true,
    valueGetter: (params) => {
      if (!params.value) return "-";
      const date = new Date(params.value);
      return date.toISOString().split("T")[0];
    },
  },

  {
    field: "startDate",
    headerName: "Start Date",
    flex: 1,
    type: "date",
    valueGetter: (params) => {
      if (!params.value) return "";
      // Strip to YYYY-MM-DD before building a Date to avoid UTC→local timezone shift
      const dateStr = typeof params.value === "string"
        ? params.value.split("T")[0]
        : new Date(params.value).toISOString().split("T")[0];
      return dateStr;
    },
  },
  {
    field: "endDate",
    headerName: "End Date",
    flex: 1,
    type: "date",
    valueGetter: (params) => {
      if (!params.value) return "";
      // Strip to YYYY-MM-DD before building a Date to avoid UTC→local timezone shift
      const dateStr = typeof params.value === "string"
        ? params.value.split("T")[0]
        : new Date(params.value).toISOString().split("T")[0];
      return dateStr;
    },
  },
  {
    field: "resumptionDate",
    headerName: "Resumption Date",
    flex: 1.5,
    type: "date",
    valueGetter: (params) => {
      if (!params.value) return "-";
      // Strip to YYYY-MM-DD before building a Date to avoid UTC→local timezone shift
      const dateStr = typeof params.value === "string"
        ? params.value.split("T")[0]
        : new Date(params.value).toISOString().split("T")[0];
      return dateStr;
    },
  },
  { field: "statusDescription", headerName: "Status", flex: 1 },
];

export const LeaveBalancesColumns = [
  { field: "id", headerName: "ID", flex: 0.3 },
  { field: "leaveType", headerName: "Leave Type", flex: 1.3 },
  { field: "firstName", headerName: "First Name", flex: 1 },
  { field: "lastName", headerName: "Last Name", flex: 1 },
  { field: "balance", headerName: "balance", flex: 1.5 },
  { field: "email", headerName: "Email", flex: 1.5 },

];



export const EmployeeColumns = [
  { field: "id", headerName: "ID", flex: 0.3 },

  {
    field: "otherNames",
    headerName: "Other Names",
    flex: 1.5,
    valueGetter: (params) =>
      `${params.row.firstName || ""} ${params.row.lastName || ""}`.trim(),
  },
  { field: "surname", headerName: "Surname", flex: 1 },
  {
    field: "hireDate",
    headerName: "Date Of Employment",
    flex: 1,
    type: "date",
    valueGetter: (params) => {
      if (!params.row.hireDate) return "-";
      const date = new Date(params.row.hireDate);
      return date.toISOString().split("T")[0]; // YYYY-MM-DD
    },
  },

  { field: "mobileNumber", headerName: "Mobile", flex: 1 },
  // {
  //   field: "baseSalary",
  //   headerName: "Basic Salary",
  //   flex: 1,
  //   valueGetter: (params) => {
  //     const salary = params.row.baseSalary;
  //     const band = params.row.salaryBandId;

  //     if (Number.isNaN(Number(salary))) {
  //       return "Not Set";
  //     }

  //     return Number(salary).toLocaleString();
  //   },
  // },
  {
    field: "nssfNo",
    headerName: "NSSF Number",
    flex: 1,
    valueGetter: (params) => params.row.nssfNo ?? "-",
  },
  {
    field: "kraPin",
    headerName: "KRA PIN",
    flex: 1,
    valueGetter: (params) => params.row.kraPin ?? "-",
  },
  { field: "jobTitle", headerName: "Last Name", flex: 1 },
  {
    field: "isActive",
    headerName: "Status",
    flex: 1,
    renderCell: (params) => {
      const isActive = params.value;
      return (
        <span
          style={{
            color: isActive ? "#4caf50" : "#f44336",
            fontWeight: "500",
          }}
        >
          {isActive ? "Active" : "Inactive"}
        </span>
      );
    },
  },
];
export const AllPoliciesColumns = [
  { field: "id", headerName: "ID", flex: 0.3 },
  { field: "leaveType", headerName: "Leave Type", flex: 1 },
  {
    field: "gender",
    headerName: "Gender",
    flex: 1,
    valueGetter: (params) => params.value || "-",
  },
  {
    field: "acrues",
    headerName: "Accrues",
    flex: 1,
    valueGetter: (params) => (params.value ? "Yes" : "No"),
  },

  {
    field: "accrualRate",
    headerName: "Accrual Rate",
    flex: 1,
    valueGetter: (params) =>
      params.row?.accrualRate != null
        ? params.row.accrualRate
        : "-",
  },
  {
    field: "accrualDate",
    headerName: "Accrual Date",
    flex: 1,
    valueGetter: (params) => {
      const value = params.row?.accrualDate;
      if (value === null || value === undefined) return "-";
      return `Day ${value}`;
    },
  },
  {
    field: "canCarryForward",
    headerName: "Carry Forward",
    flex: 1.5,
    valueGetter: (params) =>
      params.row?.canCarryForward === true
        ? "Yes"
        : params.row?.canCarryForward === false
          ? "No"
          : "-",
  },
  {
    field: "maxDaysCarryForward",
    headerName: "Max Days Carry Forward",
    flex: 1,
  },
  {
    field: "maxOpenApplications",
    headerName: "Max Open Applications",
    flex: 1,
  },

  { field: "maxDays", headerName: "Max Days", flex: 1 },
];
export const LeaveApproversColumns = [
  { field: "id", headerName: "ID", flex: 0.3 },
  { field: "firstName", headerName: "First Name", flex: 1.3 },
  { field: "lastName", headerName: "Last Name", flex: 1.3 },
  { field: "phoneNumber", headerName: "Phone No.", flex: 1.3 },
  { field: "email", headerName: "Email", flex: 1.3 },
  { field: "role", headerName: "Role", flex: 0.7 },
  { field: "roleGroup", headerName: "Role Group", flex: 1.3 },
  {
    field: "branch",
    headerName: "Branch",
    flex: 1,
    valueGetter: (params) =>
      params.row?.branch?.name || params.row?.branch || "—",
  },

  {
    field: "region",
    headerName: "Region",
    flex: 1,
    valueGetter: (params) =>
      params.row?.region?.name || params.row?.region || "—",
  },
];
export const CompanyCalendarSetupsColumns = [
  { field: "id", headerName: "ID", flex: 0.3 },
  { field: "recurringTypeId", headerName: "Recurring Type ID", flex: 1 },
  { field: "recurringType", headerName: "Recurring Type", flex: 1 },
  { field: "holiday", headerName: "Holiday", flex: 1 },
  { field: "isActive", headerName: "Is Active", flex: 1 },
];
export const userFinanceDetailsColumns = [
  { field: "id", headerName: "ID", flex: 0.3 },
  { field: "bankBranch", headerName: "Bank Branch", flex: 1 },
  { field: "bank", headerName: "Bank", flex: 1 },
  { field: "accountNumber", headerName: "Account Number", flex: 2 },
  { field: "mpesaNumber", headerName: "Mpesa Number", flex: 1 },
];

export const requisitionApproversColumns = [
  { field: "id", headerName: "ID", flex: 0.3 },
  { field: "firstName", headerName: "First Name", flex: 1.3 },
  { field: "lastName", headerName: "Last Name", flex: 1.3 },
  { field: "phoneNumber", headerName: "Phone No.", flex: 1.3 },
  { field: "email", headerName: "Email", flex: 1 },
  { field: "role", headerName: "Role", flex: 0.7 },
  { field: "roleGroup", headerName: "Role Group", flex: 1.3 },
  {
    field: "branch",
    headerName: "Branch",
    flex: 1,
    valueGetter: (params) =>
      params.row?.branch?.name || params.row?.branch || "—",
  },
  {
    field: "region",
    headerName: "Region",
    flex: 1,
    valueGetter: (params) =>
      params.row?.region?.name || params.row?.region || "—",
  },
];

export const imprestApplicationsColumns = [
  { field: "id", headerName: "ID", flex: 0.3 },
  // { field: "title", headerName: "Title", flex: 1.2 },
  {
    field: "applicantFullName",
    headerName: "Applicant",
    flex: 1,
    valueGetter: (params) =>
      params.row.applicantFullName ||
      params.row.applicantUsername ||
      params.row.createdByUsername ||
      "-"
  },
  {
    field: "amount",
    headerName: "Amount",
    flex: 0.8,
    type: "number",
    renderCell: (params) => {
      const amount = params.value;
      const code = params.row.currencyCode || "KES";
      return amount != null ? `${code} ${amount.toLocaleString()}` : "-";
    },
  },
  {
    field: "caseTitle",
    headerName: "Case",
    flex: 1,
    valueGetter: (params) => {
      return (
        params.row.caseTitle ||
        params.row.case?.title ||
        params.row.caseName ||
        "-"
      );
    },
  },
  {
    field: "description",
    headerName: "Description",
    flex: 1,
    valueGetter: (params) => {
      return (
        params.row.description ||
        params.row.case?.title ||
        params.row.caseName ||
        "-"
      );
    },
  },
  {
    field: "createdDate",
    headerName: "Created",
    flex: 0.9,
    type: "dateTime",
    valueGetter: (params) => {
      if (!params.value) return "-";
      const date = new Date(params.value);
      // Format as YYYY-MM-DD
      return date.toISOString().split("T")[0];
    },
  },
  { field: "statusText", headerName: "Status", flex: 0.8, },
];
export const imprestApplicationsPendingDisbursementColumns = [
  { field: "id", headerName: "ID", width: 70 },
  // { field: "title", headerName: "Title", flex: 1.2 },
  {
    field: "applicantFullName",
    headerName: "Applicant",
    flex: 1,
    valueGetter: (params) =>
      params.row.applicantFullName ||
      params.row.applicantUsername ||
      params.row.createdByUsername ||
      "-"
  },
  {
    field: "amount",
    headerName: "Amount",
    flex: 0.8,
    type: "number",
    renderCell: (params) => {
      const amount = params.value;
      const code = params.row.currencyCode || "KES";
      return amount != null ? `${code} ${amount.toLocaleString()}` : "-";
    },
  },
  {
    field: "caseTitle",
    headerName: "Case",
    flex: 1,
    valueGetter: (params) => {
      return (
        params.row.caseTitle ||
        params.row.case?.title ||
        params.row.caseName ||
        "-"
      );
    },
  },
  {
    field: "createdDate",
    headerName: "Created",
    flex: 0.9,
    type: "dateTime",
    valueGetter: (params) => {
      if (!params.value) return "-";
      const date = new Date(params.value);
      // Format as YYYY-MM-DD
      return date.toISOString().split("T")[0];
    },
  },
  { field: "statusText", headerName: "Status", flex: 0.8, },
  { field: "isDisbursed", headerName: "Disbursement Status", flex: 0.8, },
];

export const claimApplicationsPendingDisbursementColumns = [
  { field: "id", headerName: "ID", width: 70 },
  // { field: "title", headerName: "Title", flex: 1.2 },
  { field: "description", headerName: "Description", flex: 1, },
  {
    field: "totalAmount",
    headerName: "Amount",
    flex: 0.8,
    type: "number",
    renderCell: (params) => {
      const amount = params.value;
      const code = params.row.currencyCode || "KES";
      return amount != null ? `${code} ${amount.toLocaleString()}` : "-";
    },
  },
  {
    field: "caseTitle",
    headerName: "Case",
    flex: 1,
    valueGetter: (params) => {
      return (
        params.row.caseTitle ||
        params.row.case?.title ||
        params.row.caseName ||
        "-"
      );
    },
  },
  // {
  //   field: "createdDate",
  //   headerName: "Created",
  //   flex: 0.9,
  //   type: "dateTime",
  //   valueGetter: (params) => params.value && new Date(params.value),
  // },
  { field: "statusText", headerName: "Status", flex: 0.8, },
  { field: "isDisbursed", headerName: "Disbursement Status", flex: 0.8, },
];

export const staffClaimApplicationsColumns = [
  { field: "id", headerName: "ID", width: 70 },
  // { field: "title", headerName: "Title", flex: 1.2 },
  { field: "description", headerName: "Description", flex: 1, },
  {
    field: "totalAmount",
    headerName: "Amount",
    flex: 0.8,
    type: "number",
    renderCell: (params) => {
      const amount = params.value;
      const code = params.row.currencyCode || "KES";
      return amount != null ? `${code} ${amount.toLocaleString()}` : "-";
    },
  },
  {
    field: "caseTitle",
    headerName: "Case",
    flex: 1,
    valueGetter: (params) => {
      return (
        params.row.caseTitle ||
        params.row.case?.title ||
        params.row.caseName ||
        "-"
      );
    },
  },
  // {
  //   field: "createdDate",
  //   headerName: "Created",
  //   flex: 0.9,
  //   type: "dateTime",
  //   valueGetter: (params) => params.value && new Date(params.value),
  // },
  { field: "statusText", headerName: "Status", flex: 0.8, },
];

export const approvedClaimstApplicationsColumns = [
  { field: "id", headerName: "ID", width: 70 },
  // { field: "title", headerName: "Title", flex: 1.2 },
  { field: "description", headerName: "Description", flex: 1, },
  {
    field: "amountInBaseCurrency",
    headerName: "Amount",
    flex: 0.8,
    type: "number",
    renderCell: (params) => {
      const amount = params.value;
      const code = params.row.currencyCode || "KES";
      return amount != null ? `${code} ${amount.toLocaleString()}` : "-";
    },
  },
  {
    field: "caseTitle",
    headerName: "Case",
    flex: 1,
    valueGetter: (params) => {
      return (
        params.row.caseTitle ||
        params.row.case?.title ||
        params.row.caseName ||
        "-"
      );
    },
  },
  // {
  //   field: "createdDate",
  //   headerName: "Created",
  //   flex: 0.9,
  //   type: "dateTime",
  //   valueGetter: (params) => params.value && new Date(params.value),
  // },
  { field: "statusText", headerName: "Status", flex: 0.8, },
];

export const AllImprestSurrenderColumns = [
  { field: "id", headerName: "ID", flex: 0.2, required: true },
  { field: "applicationId", headerName: "Imprest Number", flex: 0.5, required: true },
  { field: "applicantFullName", headerName: "Applicant", flex: 1, required: true },
  { field: "totalRequested", headerName: "Total Amt", flex: 1, required: true },

  {
    field: "totalSpent",
    headerName: "Spent Amount",
    flex: 1,
  },
  { field: "refundAmount", headerName: "Refund Amount", flex: 1, required: true },
  { field: "imprestDescription", headerName: "Description", flex: 1.5 },
  {
    field: "statusText",
    headerName: "Status",
    flex: 1,
    required: true,

  },
];
export const imprestSurrenderLinesColumns = [
  { field: "id", headerName: "ID", flex: 0.3, required: true },
  { field: "accountId", headerName: "Account ID", flex: 1, required: true },
  { field: "amountRequested", headerName: " Amount Requested", flex: 1 },
  { field: "amountSpent", headerName: " Amount Spent", flex: 1, required: true },
  { field: "description", headerName: "Description", flex: 2, required: true },
];
export const staffClaimLinesColumns = [
  { field: "id", headerName: "ID", flex: 0.3, required: true },
  { field: "amount", headerName: " Amount", flex: 1, required: true },
  { field: "description", headerName: "Description", flex: 2, required: true },
];
export const allRelievers = [
  { field: "id", headerName: "ID", flex: 0.3, required: true },

  {
    field: "leaveType",
    headerName: "Leave Type",
    flex: 1,
    required: true,
  },

  {
    field: "statusDescription",
    headerName: "Status ",
    flex: 1,
    required: true,
  },

  {
    field: "applicantFirstName",
    headerName: "Applicant First Name",
    flex: 1.5,
    required: true,
  },
  {
    field: "applicantLastName",
    headerName: "Applicant Last Name",
    flex: 1.5,
    required: true,
  },
  {
    field: "relieverFirstName",
    headerName: "Reliever First Name",
    flex: 1.5,
    required: true,
  },
  {
    field: "relieverLastName",
    headerName: "Reliever Last Name",
    flex: 1.5,
    required: true,
  },

  { field: "role", headerName: "Role", flex: 1, required: true },
];

export const NSSFContributionMethodsColumns = [
  { field: 'id', headerName: 'ID', flex: 0.5, editable: false },
  { field: 'methodName', headerName: 'Method Name', flex: 1.5, editable: true },
  { field: 'description', headerName: 'Description', flex: 2, editable: true },
  { field: 'createdBy', headerName: 'Created By', flex: 1, editable: false },
  {
    field: 'createdDate',
    headerName: 'Created Date',
    flex: 1.2,
    type: 'dateTime',
    editable: false,
    renderCell: (params) => params.value ? format(new Date(params.value), 'MM/dd/yyyy HH:mm') : '',
  },
  { field: 'updatedBy', headerName: 'Updated By', flex: 1, editable: false },
  {
    field: 'updatedDate',
    headerName: 'Updated Date',
    flex: 1.2,
    type: 'dateTime',
    editable: false,
    renderCell: (params) => params.value ? format(new Date(params.value), 'MM/dd/yyyy HH:mm') : '',
  },
];

export const RelationshipTypesColumns = [
  {
    field: "id",
    headerName: "ID",
    flex: 0.5,
    hide: true,
    filterable: false,
  },
  {
    field: "relationshipName",
    headerName: "Relationship Name",
    flex: 1,
    cellClassName: "name-column--cell",
    editable: false,
    sortable: true,
    filterable: true,
  },
  {
    field: "createdBy",
    headerName: "Created By",
    flex: 0.8,
    sortable: true,
    filterable: true,
    valueGetter: (params) => params.row?.createdBy || "-",
  },
  {
    field: "createdDate",
    headerName: "Created Date",
    flex: 0.8,
    sortable: true,
    filterable: true,
    type: "date",
    valueFormatter: (params) => {
      if (!params.value) return "";
      const date = new Date(params.value);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    },
  },
  {
    field: "updatedBy",
    headerName: "Updated By",
    flex: 0.8,
    sortable: true,
    filterable: true,
    valueGetter: (params) => params.row?.updatedBy || "-",
  },
  {
    field: "updatedDate",
    headerName: "Updated Date",
    flex: 0.8,
    sortable: true,
    filterable: true,
    type: "date",
    valueGetter: (params) => {
      if (!params.value) return "-";
      const date = new Date(params.value);
      // Format as YYYY-MM-DD
      return date.toISOString().split("T")[0];
    },
  },
];

export const AllPensionRatesColumns = [
  {
    field: "id",
    headerName: "ID",
    flex: 0.5,
    hide: true,
    filterable: false,
  },
  {
    field: "ratePercentage",
    headerName: "Rate Percentage",
    flex: 1,
    cellClassName: "name-column--cell",
    editable: false,
    sortable: true,
    filterable: true,
  },
  {
    field: "description",
    headerName: "Description",
    flex: 1.5,
    cellClassName: "name-column--cell",
    editable: false,
    sortable: true,
    filterable: true,
  },
  {
    field: "isActive",
    headerName: "Is Active",
    flex: 0.5,
    type: "boolean",
    editable: false,
    sortable: true,
    filterable: true,
  },
  {
    field: "createdBy",
    headerName: "Created By",
    flex: 0.8,
    sortable: true,
    filterable: true,
  },
  {
    field: "createdDate",
    headerName: "Created Date",
    flex: 0.8,
    sortable: true,
    filterable: true,
    type: "date",
    valueFormatter: (params) => {
      if (!params.value) return "";
      const date = new Date(params.value);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    },
  },
  {
    field: "updatedBy",
    headerName: "Updated By",
    flex: 0.8,
    sortable: true,
    filterable: true,
  },
  {
    field: "updatedDate",
    headerName: "Updated Date",
    flex: 0.8,
    sortable: true,
    filterable: true,
    type: "date",
    valueGetter: (params) => {
      if (!params.value) return "";
      const date = new Date(params.value);
      // Format as YYYY-MM-DD
      return date.toISOString().split("T")[0];
    },
  },
];

export const employeePayColumns = [
  { field: "id", headerName: "ID", flex: 0.8, },
  { field: "payComponentName", headerName: "Component", flex: 1, type: "number" },
  {
    field: "notes",
    headerName: "Description",
    flex: 1,
    valueFormatter: (params) => params.value ?? "-"
  },
  {
    field: "amount",
    headerName: "Amount",
    flex: 1,
    type: "number",
    valueFormatter: (params) => params.value != null ? params.value.toLocaleString() : "-"
  },
  {
    field: "percentOfBase",
    headerName: "% of Base",
    flex: 1,
    type: "number",
    valueFormatter: (params) => params.value != null ? `${params.value}%` : "-"
  },
  { field: "baseComponentCode", headerName: "Base Component", flex: 1 },

  // ✅ Fixed date fields
  {
    field: "effectiveFrom",
    headerName: "Effective From",
    flex: 1,
    type: "date",
    valueGetter: (params) => {
      if (!params.value) return "";
      const date = new Date(params.value);
      // Format as YYYY-MM-DD
      return date.toISOString().split("T")[0];
    },
  },
  {
    field: "effectiveTo",
    headerName: "Effective To",
    flex: 1,
    type: "date",
    valueGetter: (params) => {
      if (!params.value) return "";
      const date = new Date(params.value);
      // Format as YYYY-MM-DD
      return date.toISOString().split("T")[0];
    },
  },
];

export const payComponentsColumns = [
  { field: "id", headerName: "ID", flex: 1 },
  { field: "code", headerName: "Code", flex: 1 },
  { field: "name", headerName: "Name", flex: 1 },
  { field: "componentType", headerName: "Type", flex: 1 },
  {
    field: "isTaxable",
    headerName: "Taxable",
    flex: 1,
  },
  {
    field: "isPensionable",
    headerName: "Pensionable",
    flex: 1,
  },
  {
    field: "isStatutory",
    headerName: "Statutory",
    flex: 1,
  },
  {
    field: "isRecurring",
    headerName: "Recurring",
    flex: 1,
  },
  { field: "calculationBasis", headerName: "Basis", flex: 1 },
  // {
  //   field: "defaultRate",
  //   headerName: "Default Rate",
  //   flex: 1,
  //   type: "number",
  // },
];

export const statutoryComponentsColumns = [
  { field: "id", headerName: "ID", flex: 0.3 },
  {
    field: "countryId",
    headerName: "Country",
    flex: 1,
    type: "string",
    valueGetter: (params) => params.value ?? "-",
  },
  { field: "code", headerName: "Code", flex: 1 },
  { field: "name", headerName: "Name", flex: 1 },
  { field: "calculationType", headerName: "Calculation Type", flex: 1 },
  { field: "basedOn", headerName: "Based On", flex: 1 },
  // { field: "employeeContributionType", headerName: "Employee Contribution Type", flex: 1.2 },
  // { field: "employerContributionType", headerName: "Employer Contribution Type", flex: 1.2 },
  {
    field: "employeeDefaultRate",
    headerName: "Employee Rate",
    flex: 1,
    type: "number",
    valueGetter: (params) =>
      params.row.employeeDefaultRate ?? "-",
  },
  {
    field: "employerDefaultRate",
    headerName: "Employer Rate",
    flex: 1,
    type: "number",
    valueGetter: (params) =>
      params.row.employerDefaultRate ?? "-",
  },
  {
    field: "hasRelief",
    headerName: "Has Relief",
    flex: 1,
    valueGetter: (params) =>
      params.row.hasRelief ? "Yes" : "No",
  },
  {
    field: "reliefType",
    headerName: "Relief Type",
    flex: 1,
    valueGetter: (params) =>
      params.row.reliefType && params.row.reliefType.trim() !== "-"
        ? params.row.reliefType
        : "-",
  },
  {
    field: "isActive",
    headerName: "Active",
    flex: 1,
  },
];

export const statutoryRatesColumns = [
  { field: "id", headerName: "ID", flex: 1 },
  { field: "taxableAmount", headerName: "taxableAmount", flex: 1, },
  {
    field: "lowerBound",
    headerName: "Lower Bound",
    flex: 1,
    type: "number",
    renderCell: (params) => params.value != null ? params.value.toLocaleString() : "-",
  },
  {
    field: "upperBound",
    headerName: "Upper Bound",
    flex: 1,
    type: "number",
    renderCell: (params) => params.value != null ? params.value.toLocaleString() : "-",
  },
  {
    field: "rate",
    headerName: "Rate",
    flex: 1,
    type: "number",
    valueGetter: (params) => {
      const value = params.row.rate;

      if (value === null || value === undefined) return "-";

      const numeric = Number(value);

      // If value is between 0 and 1 → treat as fraction (0.1 → 10%)
      if (numeric > 0 && numeric < 1) {
        return `${(numeric * 100).toFixed(2)}%`;
      }

      // If value is 1 or more → already a full percent (2 → 2%)
      return `${numeric.toFixed(2)}%`;
    },
  },
  {
    field: "fixedAmount",
    headerName: "Fixed Amount",
    flex: 1,
    type: "number",
    renderCell: (params) => params.value != null ? params.value.toLocaleString() : "-",
  },
  {
    field: "reliefAmount",
    headerName: "Relief Amount",
    flex: 1,
    type: "number",
    renderCell: (params) => params.value != null ? params.value.toLocaleString() : "-",
  },
  {
    field: "reliefType",
    headerName: "Relief Type",
    flex: 1,
    valueGetter: (params) =>
      params.row.reliefType ?? "-",
  },
  {
    field: "effectiveFrom",
    headerName: "Effective From",
    flex: 1,
    type: "date",
    valueGetter: (params) => {
      if (!params.value) return "";
      const date = new Date(params.value);
      // Format as YYYY-MM-DD
      return date.toISOString().split("T")[0];
    },
  },
  {
    field: "effectiveTo",
    headerName: "Effective To",
    flex: 1,
    type: "date",
    valueGetter: (params) => {
      if (!params.row.effectiveTo) return "-";
      const date = new Date(params.row.effectiveTo);
      return date.toISOString().split("T")[0];
    },
  },
];

export const PayrollColumns = [
  { field: "id", headerName: "ID", flex: 0.3 },
  { field: "periodName", headerName: "Name", flex: 0.3 },
  {
    field: "periodStart",
    headerName: "Period Starts",
    flex: 1.2,
    type: "date",
    valueGetter: (params) => {
      if (!params.value) return "";
      const date = new Date(params.value);
      // Format as YYYY-MM-DD
      return date.toISOString().split("T")[0];
    },
  },
  {
    field: "periodEnd",
    headerName: "Period End",
    flex: 1.2,
    type: "date",
    valueGetter: (params) => {
      if (!params.value) return "";
      const date = new Date(params.value);
      // Format as YYYY-MM-DD
      return date.toISOString().split("T")[0];
    },
  },
  {
    field: "payDate",
    headerName: "Pay Date",
    flex: 1.2,
    type: "date",
    valueGetter: (params) => {
      if (!params.value) return "";
      const date = new Date(params.value);
      // Format as YYYY-MM-DD
      return date.toISOString().split("T")[0];
    },
  },

  { field: "runType", headerName: "Type", flex: 1 },

  { field: "totalEmployees", headerName: "Total Employees", flex: 1.5 },
  {
    field: "totalGross",
    headerName: "Total Gross",
    flex: 1.2,
    valueFormatter: (params) => {
      if (!params.value) return "";
      return Number(params.value).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }
  },
  {
    field: "totalNet",
    headerName: "Total Net",
    flex: 1,
    valueFormatter: (params) => {
      if (!params.value) return "";
      return Number(params.value).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }
  },
  { field: "isOpen", headerName: "Open", flex: 1 },
  { field: "status", headerName: "Status", flex: 1 },
];

export const payrollDeductionColumns = [
  { field: "id", headerName: "ID", width: 70 },
  { field: "methodName", headerName: "Method Name", flex: 1.2 },
  { field: "description", headerName: "Description", flex: 2 },
  { field: "createdBy", headerName: "Created By", flex: 1 },
  {
    field: "createdDate",
    headerName: "Created",
    flex: 0.9,
    type: "dateTime",
    valueGetter: (params) => {
      if (!params.value) return "";
      const date = new Date(params.value);
      // Format as YYYY-MM-DD
      return date.toISOString().split("T")[0];
    },
  },
  { field: "updatedBy", headerName: "Updated By", flex: 1 },
  {
    field: "updatedDate",
    headerName: "Updated",
    flex: 0.9,
    type: "dateTime",
    valueGetter: (params) => {
      if (!params.value) return "";
      const date = new Date(params.value);
      // Format as YYYY-MM-DD
      return date.toISOString().split("T")[0];
    },
  },
];

export const payrollRunLinesColumns = [
  { field: "id", headerName: "ID", flex: 0.3 },
  { field: "employeeName", headerName: "Employee", flex: 1, type: "number" },
  { field: "grossPay", headerName: "Gross Pay", flex: 1, type: "number" },
  {
    field: "taxablePay",
    headerName: "Taxable Pay",
    flex: 1,
  },
  {
    field: "pensionablePay",
    headerName: "Pensionable Pay",
    flex: 1,
  },
  {
    field: "totalEarnings",
    headerName: "Total Earnings",
    flex: 1,
  },
  { field: "totalDeductions", headerName: "Total Deductions", flex: 1 },
  { field: "totalStatutoryDeductions", headerName: "TotalStatutoryDeductions", flex: 0.8 },
  {
    field: "netPay",
    headerName: "Net Pay",
    flex: 1,
    type: "number",
  },
  {
    field: "employerContributions",
    headerName: "Employer Contributions",
    flex: 1,
    type: "number",
    renderCell: (params) => params.value != null ? params.value.toLocaleString() : "-",
  },
  {
    field: "postedToGL",
    headerName: "Posted",
    flex: 0.8,
    valueGetter: (params) => params.value === true ? "Yes" : params.value === false ? "No" : "-"
  },
];

// src/data/Columns/payrollLineDetailsColumns.js
export const payrollLineDetailsColumns = [
  { field: "id", headerName: "ID", width: 80 },
  { field: "payComponentName", headerName: "Component", width: 120 },
  { field: "amount", headerName: "Amount", width: 120, type: "number" },
  {
    field: "isDeduction",
    headerName: "Deduction?",
    width: 110,
    renderCell: (p) => (p.value ? "Yes" : "No"),
  },
  {
    field: "isStatutory",
    headerName: "Statutory?",
    width: 110,
    renderCell: (p) => (p.value ? "Yes" : "No"),
  },
  { field: "calculationNotes", headerName: "Notes", flex: 1 },
];